import { render, staticRenderFns } from "./qrpay.vue?vue&type=template&id=6ac44128&scoped=true&"
import script from "./qrpay.vue?vue&type=script&setup=true&lang=ts&"
export * from "./qrpay.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./qrpay.vue?vue&type=style&index=0&id=6ac44128&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac44128",
  null
  
)

export default component.exports